module.exports = __webpack_public_path__ + "static/media/client_landing_1.59bf09f9.webp";